// extracted by mini-css-extract-plugin
export default {"content_container":"styles_content_container__pUOCf"};